<script setup>
import {computed, onMounted, ref} from 'vue';

const siteUrl = document.querySelector('meta[name="site-url"]').content;

// 検索欄のデータ
const searchWords = ref('');

//メッセージ
const messages = ref([]);
//ヘルプ一覧
const helpList = ref({});
//選択されたヘルプ
const helpDetail = ref({});

//状態 connecting
const connecting = ref(false);
//状態 詳細かどうか
const isList = ref(true);

const isFirst = ref(true);

// 検索結果のヘルプが 0 かどうか
const isHelpEmpty = computed(() => {

  // そもそも検索中でなければ false
  if ( ! isList.value) {
    return false;
  }

  // 検索欄が空なら false
  if (searchWords.value === '') {
    return false;
  }

  console.log(helpList.value);

  // 一つでもヘルプがあれば false
  return ! Object.keys(helpList.value).some(key => helpList.value[key].helps.length > 0);
});

/**
 * Ajax 通信失敗時に起動させるメソッド
 */
const _handleError = () => {
  //通信中フラグを false にする
  connecting.value = false;

  //エラーを追加
  messages.value.push('サーバーで処理に失敗しました。再度お試し頂くか、お問い合わせ下さい。');
};
/**
 * Ajax 中断時に起動させるメソッド
 */
const _handleAbort = () => {
  //通信中フラグを false にする
  connecting.value = false;

  //エラーを追加
  messages.value.push('通信が中断されました。再度お試し下さい。');
};
/**
 * Ajax タイムアウトに起動させるメソッド
 */
const _handleTimeout = () => {
  //通信中フラグを false にする
  connecting.value = false;

  //エラーを追加
  messages.value.push('通信タイムアウトしました。ネットワーク回線を確認の上、再度お試し下さい。');
};

//サーバー通信 helpList を取得
const _sync = (search = "", isFirst = false) => {
  _serverConnect((data) => {
      helpList.value = data;
    },
    'get',
    getHelps_ep + '/' + search
  );
};

//サーバー通信 helpList を取得
const _getHelp = (id) => {
  _serverConnect((data) => {
      selectHelp(data.title, data.content, id);
    },
    'get',
    getHelp_ep + '/' + id
  );
};


//サーバーと通信する部分
const _serverConnect = (onSuccess, openMethod, openUrl, sendBody = null) => {
  //通信中だったら何もしない
  if (connecting.value) {
    return Promise.reject();
  }

  //送信中フラグを on にする
  connecting.value = true;

  //非同期処理開始
  return new Promise((resolve, reject) => {
    //xhr を用意
    const xhr = new XMLHttpRequest();

    //通信失敗時
    xhr.addEventListener('error', () => {
      reject();
      _handleError();
    })
    xhr.addEventListener('timeout', () => {
      reject();
      _handleAbort();
    })
    xhr.addEventListener('abort', () => {
      reject();
      _handleTimeout();
    })

    //通信成功時処理
    xhr.addEventListener('load', event => {
      //送信中フラグを解除
      connecting.value = false;
      //成功・失敗のどちらでも response を JSON としてパースする
      let data = null;
      try {
        data = JSON.parse(event.target.response);
      }
      catch (e){
        console.log(e);
        messages.value = ['エラーが発生しました。恐れ入りますが再度お試しください。'];
        reject();
        return;
      }

      //パースに失敗
      if (data === null) {
        messages.value = ['サーバー情報のパースに失敗しました'];
        reject();
        return;
      }
      //失敗判定
      if (event.target.status >= 400) {
        messages.value = data.messages;
        reject(data.messages);
        return;
      }

      //成功したら結果を描写
      onSuccess(data);
    });

    //通信を試みる
    xhr.open(openMethod, openUrl);
    xhr.setRequestHeader('X-CSRF-Token', tokenValue.value)
    xhr.send(sendBody);
  });
};

const selectHelp = (title, content, id) => {
  helpDetail.value = {
    'title': title,
    'content': _formatText(content),
  };
  // 現在のURLを取得
  const urlParams = new URL(window.location.href);
  // idの値を取得
  const settedId = urlParams.searchParams.get('id');
  // idが存在するかチェック
  if (settedId) {
    urlParams.searchParams.set('id', id);
  }else{
    urlParams.search = '?id='+id;
  }

  window.removeEventListener('popstate', backToList);
  history.pushState({}, '', urlParams);
  window.addEventListener('popstate', backToList);

  isList.value = false;
};

const _formatText = (text) => {
  text = text.replace(/\n/g, "<br>");
  //リンクタグで囲まれた文字をリンクにする
  const pattern = /\[link:(.*?)\](.*?)\[\/link\]/g;
  return text.replace(pattern, '<a href="$1" target="_blank" rel="noopener">$2</a>');
};

const backToList = () => {
  if (isFirst.value === true){
    isFirst.value = false;
    return;
  }

  isList.value = true;
  // 現在のURLを取得
  const urlParams = new URL(window.location.href);
  // idの値を取得
  const settedId = urlParams.searchParams.get('id');
  // idが存在するかチェック
  if (settedId) {
    urlParams.searchParams.delete('id');
  }

  // history.pushState({}, '', urlParams);
};

const search = (e) => {
  backToList();
  _sync(e.target.value);
};

onMounted(() => {
  // 現在のURLを取得
  const urlParams = new URLSearchParams(window.location.search);
  // idの値を取得
  const id = urlParams.get('id');
  // idが存在するかチェック
  if (id) {
    _getHelp(id);
  }
  //init
  _sync('', true);
});
</script>

<template>
  <h1 class="lyPt8 lyPb8 lyPr4 lyPl4 lyMb16 lyTbMb24 pFont16 pFontBold pBorderBottom2pxSolidBlack"
  >ヘルプ</h1>
  <p class="lyMb16 lyTbMb24 pFont14 pFontBold">ヘルプのキーワードを入力してください。</p>
  <div class="lyMb16 lyTbMb24 ">
    <div class="pPopFormWrap pFont16">
      <input
        v-model="searchWords"
        type="text"
        id="helpSearch"
        class="pPopForm"
        placeholder=" "
        @input="search"
      >
      <label
        for="searchWords"
        class="pPopFormLabel"
      >例：ログインできない</label>
    </div>
  </div>
  <p
    v-if="isHelpEmpty"
    class="lyMb16"
  >ヘルプが見つかりませんでした。</p>
  <div
    v-else-if=" ! isList"
    class="lyMb16 lyTbMb24 lyPd16 pBackColorWhite pBorderRadius4px"
  >
    <section>
      <h1 class="pFont16 pSpFont14 pFontMedium lyMb24">{{ helpDetail && helpDetail.title ? helpDetail.title : "" }}</h1>
      <div
        class="pSpFont14"
        v-html="helpDetail && helpDetail.content ? helpDetail.content : ''"
      >
      </div>
    </section>
  </div>
  <div
    v-else
    class="lyMb16 lyTbMb24 lyPd16 pBackColorWhite pBorderRadius4px"
  >
    <p
      v-for="message in messages"
      class="pFontRed"
    >{{message}}</p>
    <section
      v-for="helpWrap in helpList"
      class="lyPt12 lyPb12"
    >
      <h2 class="lyMb16 pFont14 pFontBold">{{ helpWrap.category_name }}</h2>
      <ul class="pBorderTop1pxSolidGray4">
        <li
          v-for="element in helpWrap.helps"
          :key="element.id"
          class="pBorderBottom1pxSolidGray4"
        >
          <button
            class="lyVerticalBwCnt lyW100 lyPt8 lyPb8 pFont14 pFontBlack lyTextLeft"
            @click="selectHelp(element.title, element.content, element.id)"
          >{{ element.title }}
            <span class="lyBlock lyW32px lyMl8 lyShrinkNone"><img
              :src="siteUrl+'images/btnIconRightArrowBlack.svg'"
              width="16"
              height="16"
              alt=""
            ></span>
          </button>
        </li>
      </ul>
    </section>
  </div>
  <div class="lyMaxW400px lyBlockCnt">
    <a
      :href="siteUrl+'help#'"
      class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontWhite pBackColorGreen pBorderRadius2px pHoverSlideChange"
    >ヘルプ一覧に戻る</a>
  </div>
</template>
